import api from "../utils/API";

const getBlobErrorMessage = async (blob) => {
  try {
    const text = await blob.text();
    const payload = JSON.parse(text);
    return payload.message || payload.error || "Le serveur n'a pas renvoye un fichier valide.";
  } catch {
    return "Le serveur n'a pas renvoye un fichier valide.";
  }
};

const ensureFileResponse = async (response) => {
  const contentType = response.headers?.["content-type"] || response.data?.type || "";

  if (contentType.includes("application/json")) {
    throw new Error(await getBlobErrorMessage(response.data));
  }

  if (!response.data || response.data.size === 0) {
    throw new Error("Le fichier est vide ou introuvable.");
  }

  return response;
};

const downloadFile = (id) => {
  return api.get(`/candidatsmanagement/downloadfile/${id}`, {
    responseType: "blob",
  }).then(ensureFileResponse);
};

const getCvBlob = (cv) => {
  return api.get(`/candidatsmanagement/candidat/${cv}`, {
    responseType: "blob",
  }).then(ensureFileResponse);
};

const getCollaborateurDocBlob = (fileName) => {
  return api.get(`/Collaborateur/document/${fileName}`, {
    responseType: "blob",
  }).then(ensureFileResponse);
};

const deleteFile = (id) => {
  return api.delete(`/candidatsmanagement/deleteFile/${id}`);
};

const fileExistsCache = new Map();
let pendingIds = new Set();
let pendingBatch = null;

const checkFileExists = (id) => {
  if (!id) return Promise.resolve(false);
  if (fileExistsCache.has(id)) return fileExistsCache.get(id);

  pendingIds.add(id);
  if (!pendingBatch) {
    pendingBatch = new Promise((resolve) => setTimeout(resolve, 0)).then(() => {
      const ids = [...pendingIds];
      pendingIds = new Set();
      pendingBatch = null;
      return api.post(`/candidatsmanagement/files/exists`, { ids }).then((res) => res.data);
    });
  }

  const promise = pendingBatch
    .then((result) => result?.[id] !== false)
    .catch(() => {
      fileExistsCache.delete(id);
      return true;
    });
  fileExistsCache.set(id, promise);
  return promise;
};

export { deleteFile, downloadFile, getCvBlob, getCollaborateurDocBlob, checkFileExists };
